export default __webpack_public_path__ + "static/media/regulatory--motorcycles-only--g2.1e5763c9.png";